import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_employer_use_any_other_coercive_tactics_to_force_wrkrs'

export const dataPointDefinition = {
  retracedId: 'does_the_employer_use_any_other_coercive_tactics_to_force_wrkrs',
  name: 'Does the employer use any other coercive tactics to force workers to work?',
  description:
    "This question does not cover restrictions on movement, or other efforts to coerce workers to work or stay on the job through violence; withholding of wages; disciplinary measures; punishment for participation in a strike; restricted access to their personal documents; threats of deportation, visa cancellation, or reporting to the authorities; or forced overtime, which are recorded elsewhere.\r\r\n\r\r\nThis question includes coercive tactics to overwhelm workers' ability to make decisions in their own interest, e.g., employers giving workers drugs to induce addiction or dependence, using psychological or spiritual (such as witchcraft) manipulation, constant surveillance, or other physical means to control workers and force them to work.",
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-for-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 9930,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
